import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Signal } from '@models/dashboard/signal';
import { ChartSignalEntry } from '@models/pages/user-defined-page/chart-signal-entry';
import { TranslateService } from '@ngx-translate/core';
import { ChartsHelperService } from '@services/charts/helper/charts-helper.service';

@Component({
    selector: 'scitis-widget-configuration-signals-selector',
    templateUrl: './widget-configuration-signals-selector.component.html',
    styleUrls: ['./widget-configuration-signals-selector.component.scss'],
    standalone: false
})
export class WidgetConfigurationSignalsSelectorComponent implements OnInit {

  @Input()
  selectedSignalsIds: number | number[] = -1;

  @Input()
  items: Signal[] = [];

  @Input()
  disabledItems: number[] = [];

  @Input()
  multiSelection: boolean = true;

  @Input()
  showColor: boolean = true;

  @Input()
  validate: boolean = false;

  @Input()
  isCommandWidget: boolean = false;

  @Output()
  signalSelectionChanged: EventEmitter<Signal | Signal[]> = new EventEmitter<Signal | Signal[]>();

  constructor(private translate: TranslateService,
              private chartsHelperService: ChartsHelperService) {
  }

  public get isValid() {
    if (!this.selectedSignalsIds) {
      return false;
    }

    if (this.multiSelection) {
      return (this.selectedSignalsIds as number[]).length > 0;
    } else {
      return (this.selectedSignalsIds as number) > 0;
    }


  }

  public get notFoundLabel(): string {
    if (!this.items || this.items.length === 0) {
      return this.translate.instant('There are no available signals to select from');
    }
    return this.translate.instant('No signals found');
  }

  public get placeholder(): string {
    if (!this.items || this.items.length === 0) {
      return this.translate.instant('There are no available signals to select from');
    }
    return this.translate.instant('Select signals....');
  }

  ngOnInit(): void {
    this.updateDisabledItems();
    this.items.sort((a, b) => {
      return a.label.localeCompare(b.label);
    });
  }

  public onSignalSelected($event: Signal | Signal[]) {
    this.signalSelectionChanged.emit($event);
  }

  public getSignalUnit(signal: Signal | ChartSignalEntry) {
    return this.chartsHelperService.getSignalUnit(signal);
  }

  private updateDisabledItems() {
    this.items.forEach((item) => {
      item.disabled = this.disabledItems.includes(item.id) && !(this.selectedSignalsIds as number[]).includes(item.id);
    });
  }
}
